import { render, staticRenderFns } from "./ClientEvents.vue?vue&type=template&id=9d03286a&scoped=true"
import script from "./ClientEvents.vue?vue&type=script&lang=js"
export * from "./ClientEvents.vue?vue&type=script&lang=js"
import style0 from "./ClientEvents.vue?vue&type=style&index=0&id=9d03286a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d03286a",
  null
  
)

export default component.exports